import * as React from 'react';

import MentionCardInformation from 'components/mention-card/mention-card-information/MentionCardInformation';

import { getTruncatedValue } from 'components/mention-card/utils/mention-card';

class MentionCardInformationInstagram extends MentionCardInformation {
  renderCaption(): React.ReactNode | undefined | null {
    const { post, maxRowCount } = this.props;
    const value = post && post.caption;
    const truncatedValue = getTruncatedValue(value, maxRowCount, 'caption');

    return this.renderSection('label_caption', truncatedValue);
  }

  render(): React.ReactNode {
    const { isLimitedKeywords } = this.props;

    return (
      <div
        className="mention-card-information mention-card-information-instagram"
        data-qa="mention-card-information-instagram"
      >
        {this.renderCaption()}
        {this.renderKeywords('hashtags')}
        {
          !isLimitedKeywords && (
            <React.Fragment>
              {this.renderKeywords('mentions')}
              {this.renderKeywords('tags')}
            </React.Fragment>
          )
        }
      </div>
    );
  }
}

export default MentionCardInformationInstagram;
